
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Section } from "../../../components/util/section";
import { client } from "../../../../tina/__generated__/client";
import { TinaMarkdown } from "tinacms/dist/rich-text";
import styles from "../../../components/blog/BlogPost.module.css";
import { FaXTwitter } from "react-icons/fa6";
export default function Author({ author }) {
    if (!author) {
        return null;
    }
    const normalizedXHandle = author.xHandle?.replace(/^@/, "");
    // return <pre>{JSON.stringify(author, null, 4)}</pre>;
    return (<Section className="flex-1 overflow-hidden bg-altblue-600">
      <div className={`absolute inset-y-0 right-0 z-0 w-96 pointer-events-none ${styles.right}`}/>
      <div className="relative w-full h-full bg-altblue-600">
        <div className={`w-full relative flex justify-center p-16 md:p-20
      `}>
          <div className="relative z-10 w-[960px]">
            <h4 className="mb-3 text-sm font-semibold uppercase text-gray-50">
              Authors
            </h4>
            <h2 className={`w-full relative	text-4xl md:text-5xl mb-1 text-gray-50 font-semibold`}>
              {author.name}
            </h2>
            <h5 className="text-xl text-gray-400">{author.title}</h5>
            {normalizedXHandle && (<a href={`https://x.com/${normalizedXHandle}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 mt-2 text-sm text-gray-400 hover:text-gray-200 transition-colors">
                <FaXTwitter className="w-4 h-4 shrink-0" aria-hidden="true"/>@
                {normalizedXHandle}
              </a>)}
            <div className="prose w-full max-w-[610px] py-8 text-gray-50">
              <TinaMarkdown content={author._body}/>
            </div>
          </div>
        </div>
      </div>

      {/* <Container size="large" width="small">
          <Posts data={posts} />
        </Container> */}
    </Section>);
}
export const getStaticPaths = async () => {
    const authorConnection = await client.queries.authorConnection();
    const authors = authorConnection.data.authorConnection.edges;
    const basePaths = authors.map((author) => {
        return {
            params: {
                filename: author.node._sys.filename,
            },
        };
    });
    const paths = basePaths.map((path) => ({ ...path, locale: "en" }));
    return {
        paths,
        fallback: true,
    };
};
const getStaticProps = async ({ params }) => {
    const { filename } = params;
    const variables = {
        relativePath: `${filename}.md`,
    };
    const props = await client.queries.author(variables);
    const author = props.data.author;
    // const postsResponse = await client.queries.postConnection({
    //   filter: {
    //     locale: { eq: locale },
    //     author: {
    //       author: {
    //         name: { eq: filename },
    //       },
    //     },
    //   },
    // });
    // const posts = postsResponse.data.postConnection.edges;
    return {
        props: {
            // posts,
            author,
        },
    };
};

    async function __Next_Translate__getStaticProps__1a042aa3e01__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/author/[filename]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a042aa3e01__ as getStaticProps }
  